<template lang="pug">
  server-data(
    ref="serverData"
    v-bind="serverDataAttrs"
    v-slot:default="{ serverData, selectProps, loadMoreItems, search }"
    :method="(val) => $api.teachers.index(val, { many: true, test: 'test' })"
  )
    v-autocomplete-more(
      v-bind="{ ...selectProps, ...$attrs }"
      :value="value"
      item-text="full_name"
      item-value="user_id"
      :label="label"
      rounded
      @update:search-input="search"
      @load-more-items="loadMoreItems"
      @input="$emit('input', $event)"
    )
    //- v-autocomplete(
    //-   v-bind="{ ...selectProps, ...$attrs }"
    //-   v-on="$listeners"
    //-   :value="value"
    //-   item-text="full_name"
    //-   item-value="user_id"
    //-   :label="label"
    //-   rounded
    //-   @input="$emit('input', $event)"
    //- )
</template>

<script>
export default {
  name: 'SelectCourse',
  props: {
    value: { type: [Number, Object, Array], default: null },
    serverDataAttrs: { type: Object, default: () => ({}) },
    label: { type: String, default: 'Преподаватель' },
  },
};
</script>
